import { planningAPI } from "../../axios";

export const actions = {

    //ExtensionActivityFile
    GetExtensionActivityFileByActivity(context, data){
        return planningAPI.get(`ExtensionActivityFile/ExtensionActivity/${data}`);
    },
    UpdateExtensionActivityFile(context, data){
        return planningAPI.put(`ExtensionActivityFile/Update/${data.id}`, data);
    },
    DeleteExtensionActivityFile(context, data){
        return planningAPI.delete(`ExtensionActivityFile/Remove/${data}`);
    },
    CreateExtensionActivityFile(context, data){
        return planningAPI.post(`ExtensionActivityFile/Add`, data);
    },

}